// extracted by mini-css-extract-plugin
export default {"container":"slot-card_container__R+-l7","card":"slot-card_card__VK5VS","cardList":"slot-card_cardList__Hgmvq","editButton":"slot-card_editButton__wLwne"};